$(function(){
    const sliders = $('.elementor-widget-dieste-slider, .elementor-widget-dieste-slider-hero, .elementor-widget-dieste-carousel');
    sliders.each(function() {
        const $el = $(this);
        const settings = parseSliderSettings($el.data('settings'));
        var id = $el.data('id');
        var tmp = new Swiper('[data-id="' + id + '"] .swiper-container', settings);
    });    
    $(".swiper-container").hover(function() {
        $settings = $($(this).parents('.elementor-widget-dieste-slider, .elementor-widget-dieste-slider-hero, .elementor-widget-dieste-carousel')).data().settings;
        if ('yes' === $settings.pause_on_hover) {
            (this).swiper.autoplay.stop();
        }
    }, function() {
        (this).swiper.autoplay.start();
    });
});

function parseSliderSettings(settings) {
    let sliderSettings = {
        handleElementorBreakpoints: true,
        speed: settings.speed,
        slidesPerView: settings.slides_to_show,
        spaceBetween: 0,
        loop: 'yes' === settings.infinite,
        navigation: {
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            hideOnClick: false,
            lockClass: 'swiper-button-lock',
            nextEl: '.elementor-swiper-button-next',
            prevEl: '.elementor-swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
        },
        effect: settings.effect,
    };
    if (settings.autoplay = 'yes') {
        sliderSettings.autoplay = {
            delay: settings.autoplay_speed,
            disableOnInteraction: true,
            enabled: true,
            reverseDirection: false,
            waitForTransition: true,
        }
    }
    return sliderSettings;
}